const env = {
    url: "https://manage.rebatedekho.com/api/v1"
    // url: "http://127.0.0.1:8000/api/v1"
}

export default env;